import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import Searchbar from "../../../../Components/Searchbar/Searchbar";
import CustomButton from "../../../../Components/Button/CustomButton";
import { Link } from "react-router-dom";
import DietTable from "../../../../Components/Table/DietTable";
import { GetDietPlans } from "../../../../APIs/Function/Workout/DietPlans/GetDietPlans";
import { SearchDebouncing } from "../../../../APIs/Search/SearchDebouncing";
import Loader from "../../../../Components/Loader/Loader";

const DietPlans = () => {
  const [DietData, setDietData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [searchData, setSearchData] = useState([]);

  const handleDiet = async () => {
    try {
      setLoading(true);
      let res = await GetDietPlans();
      setDietData(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value.trim();
    if (searchValue.length === 0) {
      setSearchData([]);
      setSearched(false);
      return;
    }
    try {
      await SearchDebouncing(6, searchValue, setSearchData);
      setSearched(true);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleDiet();
  }, []);

  return (
    <Box>
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <Loader />
        </Box>
      ) : (
        <Box
          sx={{
            boxSizing: "border-box",
            p: 2,
            height: "100vh",
            overeflow: "auto",
          }}
        >
          {/* searchbar */}
          <Box>
            <Searchbar placeholder={"search"} onChange={handleSearch} />
          </Box>
          {/* table */}{" "}
          {searched && searchData.length > 0 ? (
            <DietTable
              setDietData={setDietData}
              DietData={searchData}
              Column1={"#"}
              Column2={"Photo"}
              column3={"Title"}
              Column4={"Action"}
            />
          ) : !searched ? (
            <DietTable
              setDietData={setDietData}
              DietData={DietData}
              Column1={"#"}
              Column2={"Photo"}
              column3={"Title"}
              Column4={"Action"}
            />
          ) : (
            ""
          )}
          <Box
            sx={{
              display: "flex",
              mt: "25px",
              justifyContent: "end",
              width: "100%",
            }}
          >
            <Link to={"/adddietplans"}>
              <CustomButton
                sx={{
                  width: "100%",
                  bgcolor: "#31AEF4",
                  "&:hover": {
                    bgcolor: "#31AEF4",
                  },
                }}
              >
                ADD +
              </CustomButton>
            </Link>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default DietPlans;
